// extracted by mini-css-extract-plugin
module.exports = {"newUsers":"createAccount_newUsers__FFzy3 bg-accent w-[202px] font-sans font-bold text-[13px] leading-[16px] whitespace-nowrap text-white py-[7px] pl-[42px] pr-[17px]"};